export const combineStringList = (stringList: string[]) => {
  if (stringList.length === 0) {
    return '';
  }

  if (stringList.length === 1) {
    return stringList[0];
  }

  const last = stringList[stringList.length - 1];
  return `${stringList.slice(0, -1).join(', ')} and ${last}`;
};
